import { ConfigProvider, Empty, Input, Select } from "antd";
import PrimaryButton from "./Buttons/PrimaryButton";
import { LeftOutlined } from "@ant-design/icons";
import pray from "../assets/icons/SelectIcon.svg";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { customFilter } from "../domains/profile/sponsor/orphans/utils";
import TransparentButton from "./Buttons/TransparentButton";
const { Search } = Input;

interface Props {
  state: any;
  setFiltredList: (list: any[], value: boolean) => void;
  updateIsCompleted?: () => void;
  onCategoryChange?: (value: number | null) => void; 
}
const SearchWithSelect = ({
  state,
  updateIsCompleted,
  setFiltredList,
  onCategoryChange,
}: Props) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState<any>(null);
  const [searchedValue, setSearchedValue] = useState<any>("");
  const {
    items,
    options,
    fieldsName,
    typeFieldName,
    showIscompletedButton,
    titleBtnCompleted,
    initialItems,
    placeholderSelect,
  } = state;
  const onSearch = (selected: any, toSearch: string) => {
    if (selected === null && toSearch === "") {
      setFiltredList(initialItems, false);
      return;
    }
    let filtered = [...items];
    if (selected)
      filtered = filtered.filter(
        (project: any) => project[typeFieldName] === selected
      );
    if (toSearch) {
      filtered = customFilter(toSearch, filtered, fieldsName);
    }
    setFiltredList(filtered, true);
  };
  useEffect(() => {
    onSearch(selectedType, searchedValue);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);
  useEffect(() => {
    setSearchedValue("");
    setSelectedType(null);
  }, [state.options]);
  return (
    <>
      <div className="takaful--cases-header-content">
        <div className="takaful--cases-header-box">
          <img alt="" src={pray} />
          <ConfigProvider
            renderEmpty={() => (
              <Empty
                description={
                  <span className="takaful--select-empty">لا توجد بيانات</span>
                }
              />
            )}
          >
            <Select
              showSearch
              popupMatchSelectWidth={300}
              className={`takaful--select takaful--selects`}
              size="large"
              placeholder={placeholderSelect}
              onChange={(e) => {
                const selected = options.find((el: any) => el.value === e);
                const label = selected?.label ?? null;
                setSelectedType(label);
                if (onCategoryChange) {
                  onCategoryChange(selected?.value ?? null); // ✅ direct use
                }
              }}
              options={options}
              dropdownRender={(menu) => (
                <div className="takaful--select-dropdown">{menu}</div>
              )}
              value={selectedType}
              allowClear
              onClear={() => {
                onSearch(null, searchedValue);
              }}
            />
          </ConfigProvider>
        </div>
        <Search
          className="takaful--search"
          placeholder="ادخل كلمة البحث"
          allowClear
          enterButton
          value={searchedValue}
          onPressEnter={() => {
            onSearch(selectedType, searchedValue);
          }}
          onClear={() => onSearch(selectedType, "")}
          type="text"
          onChange={(e) => setSearchedValue(e.target.value)}
        />
        <PrimaryButton
          className="takaful--primary-button"
          icon={<LeftOutlined />}
          title={t("cases.button")}
          onClick={() => onSearch(selectedType, searchedValue)}
        />
        {showIscompletedButton && updateIsCompleted && (
          <TransparentButton
            className="takaful--completed-button"
            title={titleBtnCompleted}
            onClick={() => updateIsCompleted()}
          />
        )}
      </div>
    </>
  );
};
export default SearchWithSelect;
